/** @format */

import { Chain, Environment, Order } from '@shared/data-access/interfaces';
import { Observable, throwError } from 'rxjs';

import { ConstantsService } from 'libs/my-account/data-access/services/src/lib/constants.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TrackOrdersService {
	constructor(
		private httpService: HttpService,
		private constants: ConstantsService,
		private chain: Chain,
		private environment: Environment
	) {}

	public getOrderDetail(orderNumber: string, billingZip: string): Observable<Order> {
		const url = `${this.environment.baseUrls.orderService}/v3/orders/${orderNumber}?billingZip=${billingZip}&chain=${this.chain.chainIdentifierAbbr}`;
		return this.httpService.get<Order>(url, 0, { useApiAuth: true }).pipe(
			catchError((error: HttpErrorResponse) => {
				const errorMessage = this.handleTrackOrderError(error);
				return throwError(errorMessage);
			})
		);
	}

	public getOrderDetailByEmail(orderNumber: string, emailAddress: string): Observable<Order> {
		const url = `${this.environment.baseUrls.orderService}/v3/orders/${orderNumber}?emailAddress=${emailAddress}&chain=${this.chain.chainIdentifierAbbr}`;
		return this.httpService.get<Order>(url, 0, { useApiAuth: true }).pipe(
			catchError((error: HttpErrorResponse) => {
				const errorMessage = this.handleTrackOrderError(error);
				return throwError(errorMessage);
			})
		);
	}

	public getOrder(orderNumber: string): Observable<Order> {
		const url = `${this.environment.baseUrls.orderService}/v3/orders/${orderNumber}?chain=${this.chain.chainIdentifierAbbr}`;
		return this.httpService
			.get<Order>(url, 0, { withCredentials: true, useApiAuth: true })
			.pipe(
				catchError((error: HttpErrorResponse) => throwError(error))
			);
	}

	private handleTrackOrderError(error: any): string {
		if (error.status === 404) {
			console.error(this.constants.errors.orderNotFound);
			return this.constants.errors.orderNotFound;
		}

		return this.constants.errors.unknownError;
	}
}
